import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';

import { AdminPermitDetail } from '../../models/permit.model';
import { PermitV2Service } from '../../services/permits.abstract.service';
import { MessageService } from '../../../global/services/message/message.abstract.service';
import { PermitPrintDialogComponent, PermitPrintDialogData } from '../permit-print-dialog/permit-print-dialog.component';

@Component({
    selector: 'app-permit-internal-panel',
    templateUrl: './permit-internal-panel.component.html',
    styleUrls: ['./permit-internal-panel.component.scss'],
})
export class PermitInternalPanelComponent implements OnInit, OnDestroy {
    @Input() permit: AdminPermitDetail;

    @Output() permitUpdated = new EventEmitter<void>();
    @Output() closed = new EventEmitter<void>();

    tagCtrl = new FormControl('');
    separatorKeyCodes: number[] = [ENTER, COMMA];

    private destroy$ = new Subject<void>();

    constructor(
        private permitService: PermitV2Service,
        private messageService: MessageService,
        private dialog: MatDialog,
        private translate: TranslateService,
    ) {}

    ngOnInit(): void {}

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    print(): void {
        this.dialog.open<PermitPrintDialogComponent, PermitPrintDialogData>(PermitPrintDialogComponent, {
            data: { permit: this.permit },
            panelClass: 'no-padding-dialog',
            autoFocus: false,
        });
    }

    close(): void {
        this.closed.emit();
    }

    addTag(event: MatChipInputEvent): void {
        const value = (event.value || '').trim();
        if (value && !(this.permit?.tags || []).includes(value)) {
            this.savePermitTags([...(this.permit?.tags || []), value]);
        }
        event.chipInput?.clear();
        this.tagCtrl.setValue(null);
    }

    removeTag(tag: string): void {
        this.savePermitTags((this.permit?.tags || []).filter((t) => t !== tag));
    }

    private savePermitTags(tags: string[]): void {
        this.permitService
            .updateTags(this.permit._id, { tags })
            .pipe(take(1))
            .subscribe({
                next: () => {
                    this.permit = { ...this.permit, tags };
                    this.permitUpdated.emit();
                },
                error: () => {
                    this.messageService.error(this.translate.instant('permit.manage.common.error'));
                },
            });
    }
}
